var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobiledrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 4.00075L2.00094 0.000331402L0 1.99983L6 7.99976L12 1.99983L9.99906 0.000331402L6 4.00075Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobiledrop);
export default __webpack_public_path__ + "static/media/mobiledrop.c5e8879ec9ee22e5b6ddca9cb8dee276.svg";
export { ForwardRef as ReactComponent };